enum StatusCodeType {
  Success = 200,
  MovedPermanently = 301,
  MovedTemporarily = 302,
  Invalid = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
  NotImplemented = 501,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504
}

export default StatusCodeType
